import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const EmailVerificationComponentActions = createActionGroup({
  source: 'Email Verification Component',
  events: {
    Initialize: props<{ token: string }>(),
    'Validate Token Success': emptyProps(),
    'Validate Token Error': emptyProps(),
  },
});
